<template>
  <div>
    <h1>글 상세보기</h1>
    <b-container fluid>
      <b-row class="my-1">
        <b-col sm="2">
          <label for="input-default">제목:</label>
        </b-col>
        <b-col sm="10">
          {{title}}
        </b-col>
        <b-col sm="2">
          <label for="input-default">내용:</label>
        </b-col>
        <b-col sm="10">
          <div v-html="content"></div>
        </b-col>
        <p :key="index" v-for="(file, index) in fileList">{{file.REAL_FILE_NAME}}</p>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  components:{
  },
  data(){
    return {
      title: "",
      content: "",
      idx : this.$route.params.idx,
      fileList : null
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      let idx = this.idx;

      axios.post('http://localhost:8080/test/getNoticeInfo', idx)
      .then(response => {
          if(response.status == 200){
            let noticeData = response.data.NOTICE;
            this.title = noticeData.TITLE;
            this.content = noticeData.CONTENT;
            this.fileList = noticeData.FILE_LIST;
          }
      })
      .catch(() => {
      })
      .then(() => {
      });
    })
  },
  computed: {
      check_completeHidden(){
        return this.$store.state.modal.completeHiddenYn;
      }
    },
    watch: {
      check_completeHidden(val) {
        if(val === "Y"){
          this.$nextTick(() => {
            let focusItem = this.$store.state.modal.focusItem;
            this.$refs[focusItem].focus()
          })
        }
      }
    },
  methods:{
  }
}
</script>
<style scoped lang="scss">
  .bootstrapComtain ::v-deep {
    @import "~bootstrap/dist/css/bootstrap.min";
  }
</style>
